





























import { windowHelper } from '@tencent/ppd-base-libs';
import { LargeBanner } from '@/types/home-newest';
import { defineComponent, ref, PropType, computed, toRefs } from '@vue/composition-api';
import { useCountdown } from '../use-countdown';

export default defineComponent({
  name: 'largeAd',
  props: {
    item: {
      type: Object as PropType<LargeBanner>,
      required: true,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const biExt = computed(() => props.item.reportInfo);
    const { isShow } = toRefs(props);
    /** 图片是否加载完成 */
    const isImgLoaded = ref(false);
    /** 是否展示 */
    const isShowImg = computed(() => props.item.img && isImgLoaded.value);
    /** 关闭大屏 */
    const handleClose = function () {
      emit('close');
    };
    const { time } = useCountdown(isShowImg, isShow, handleClose);
    time.value = props.item.countdown || 8;
    return {
      biExt,
      time,
      handleClose,
      /** 跳转活动页面 */
      goAct() {
        if (!props.item.url) {
          return;
        }
        windowHelper.redirect(props.item.url, 300);
      },
      handleImgLoaded() {
        isImgLoaded.value = true;
        emit('imgLoad');
      },
    };
  },
});
